module.exports = {"431126001":"文庙街道","431126002":"舜陵街道","431126003":"桐山街道","431126004":"东溪街道","431126101":"天堂镇","431126102":"水市镇","431126103":"湾井镇","431126104":"冷水镇","431126105":"太平镇","431126106":"禾亭镇","431126107":"仁和镇","431126108":"中和镇","431126109":"柏家坪镇","431126110":"清水桥镇","431126111":"鲤溪镇","431126112":"保安镇","431126200":"九疑山瑶族乡","431126202":"五龙山瑶族乡","431126203":"棉花坪瑶族乡","431126204":"桐木漯瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431126.json
// module id = 1910
// module chunks = 0